// -------------- POS Page --------------
export const POS_FIELD_ERROR       = 'POS_FIELD_ERROR';
export const POS_FIELD_RESET_ERROR = 'POS_FIELD_RESET_ERROR';
export const POS_GET_ITEM          = 'POS_GET_ITEM';
export const POS_SET_ITEM          = 'POS_SET_ITEM';
export const POS_USER_ID           = 'POS_USER_ID';



// --------- POS Page ---------
export function posFieldError(field, fieldData = {}) {
    return { type: POS_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function posFieldResetError(field, fieldData = {}) {
    return { type: POS_FIELD_RESET_ERROR }
}
export function posSetItem(targetItem) {
    return { type: POS_SET_ITEM, data: targetItem }
}
export function posGetItem(targetItem) {
    return { type: POS_GET_ITEM, data: targetItem }
}

